import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import "../../../styles/AddEditModel.scss";
import { baseURL } from "../../BaseUrl";
import Select from "react-select";
import * as swal from "../../Consturl/SwalAlert";

export default function EditSubCategory(props) {
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const resPassData = JSON.parse(sessionStorage.getItem("usrlgndtls"));

  // console.log("SUBSCRIPTION:", resPassData.subscriptionId);

  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };

  const [categoryList, setCategoryList] = useState([]);
  const [parentCategoryId, setParentCategoryID] = useState(
    props.parentCategoryID
  );
  const [subCategoryName, setSubCategoryName] = useState(props.subCategoryName);
  const [categoryDescription, setCategoryDescription] = useState(
    props.subCatDescription
  );
  // const [categoryId, setCategoryID] = useState(props.subCategoryID);
  const [enableStatus, setEnableStatus] = useState(1);
  const [categoryVal, setCategoryVal] = useState("");
  const [fieldReq, setFieldReq] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    alertType: null,
    message: null,
  });

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/Category/BindParentCategoryDropDown`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setCategoryList(
            res.result.map((data) => {
              return {
                value: data.categoryID,
                label: data.name,
              };
            })
          );
        } else {
          setCategoryList([]);
        }
      });
  };

  useEffect(() => {
    if (parentCategoryId !== null && parentCategoryId !== 0) {
      categoryList.filter((cat) => {
        if (parentCategoryId == cat.value) {
          setCategoryVal(cat);
        }
      });
    }
  }, [parentCategoryId, categoryList]);

  const editSubCategoryData = () => {
    if (subCategoryName !== "" && subCategoryName !== null) {
      const subCategoryDetails = {
        categoryID: props.subCategoryID,
        subscriptionID: resPassData.subscriptionId,
        name: subCategoryName,
        description: categoryDescription,
        addedByID: resPassData.userId,
        parentCategoryID: parentCategoryId,
        status: enableStatus,
      };

      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: travelizeAuth,
        body: JSON.stringify(subCategoryDetails),
      };
      fetch(`${baseURL}/api/Category/UpdateCategory`, requestOption)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            props.handleClose();
            props.fetchProductCategory();
            props.fetchSubCategoryById();
            swal.showAlert("Success", `${res.message}`, "success");
          } else {
            props.handleClose();
            swal.showAlert("Fail", `${res.errorMessage}`, "warning");
          }
        });
    } else {
      setFieldReq(true);
      setAlertMessage({
        alertType: "fail",
        message: "Enter Sub-Category Name",
      });
    }
  };

  return (
    <div>
      <Modal
        show={props.editSubCategory}
        // onHide={props.handleClose}
        className="main_model add-edit-model"
      >
        <div className="add-edit-heading">
          <h6 className="add-edit-head">EDIT SUB-CATEGORY</h6>
          <i className="fa fa-times" onClick={props.handleClose} />
        </div>
        <form>
          <div className="container add-edit">
            <div className="product-inputs">
              <div className="mb-2">
                <Select
                  className="react-select-container-list model-select"
                  classNamePrefix="react-select-list"
                  defaultValue={categoryList[null]}
                  options={categoryList}
                  placeholder="Select Category"
                  value={categoryVal}
                  onInputChange={categoryList.label}
                  onChange={(data) => setParentCategoryID(data.value)}
                  isSearchable={true}
                />
              </div>
              <div className="mb-2">
                <input
                  type="text"
                  className="form-control form add-input"
                  placeholder="Sub-Category Name"
                  value={subCategoryName}
                  onChange={(e) => setSubCategoryName(e.target.value)}
                />
                {fieldReq && subCategoryName == "" ? (
                  <small
                    id={`Error${alertMessage.alertType}`}
                    className="form-text text-muted "
                  >
                    {`${alertMessage.message}`}
                  </small>
                ) : (
                  ""
                )}
              </div>

              <div className="mb-2">
                <Form.Control
                  as="textarea"
                  rows="2"
                  cols="20"
                  name="usrtxt"
                  wrap="hard"
                  className="form-control form add-input-area"
                  id="addressArea"
                  placeholder="Description"
                  required
                  value={categoryDescription}
                  onChange={(e) => setCategoryDescription(e.target.value)}
                />
              </div>

              <div className="mt-3">
                <span className="enable-status d-flex">
                  <h6>Enable</h6>
                  <span className="enable-radio-client d-flex">
                    <div className="form-check enable-radio-status">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault1"
                        checked={enableStatus == 1 ? true : false}
                        onChange={() => setEnableStatus(1)}
                      />
                      <label
                        className="form-check-label"
                        for="flexRadioDefault1"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check enable-radio-status">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        checked={enableStatus == 0 ? true : false}
                        onChange={() => setEnableStatus(0)}
                      />
                      <label
                        className="form-check-label"
                        for="flexRadioDefault2"
                      >
                        No
                      </label>
                    </div>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </form>
        <div className="btns-save-cancel">
          <div className="basefare-save-button">
            <button
              onClick={editSubCategoryData}
              type="button"
              className="btn btn-save-up"
              data-bs-dismiss="modal"
            >
              Save
            </button>
          </div>
          <div className="products-cancel-button">
            <button
              onClick={props.handleClose}
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
